export const contactFormInitialValues = {
  homeAddress: '',
  homeZipCode: '',
  homePostalAddress: '',
  homePhone: '',
  homeOtherPhone: '',
  homeMobilePhone: '',
  homeEMail: '',
  workPlace: '',
  workAddress: '',
  workZipCode: '',
  workPostalAddress: '',
  workPhone: '',
  workEMail: '',
  otherAddress: '',
  otherPhone: '',
  otherPostalAddress: '',
  otherZipCode: '',
  preferredAddressType: '',
  awards: [],
  invitations: [],
  reminders: [],
  consumed: [],
  advertisements: [],
  organizationId: 0,
  tapLocation: '',
}
